import { Modal } from "../../../../components/modal/modal.jsx";

export default function CalendarModal({ show = false, onClose, title, children }) {
    return (
        <Modal 
            open={!!show}
            setOpen={(value) => {
                if (!value) onClose?.()
            }}
            title={title}
            showCloseButton={true}
            isCloseClick={true}
            className="w-6/12"
        >
            <Modal.Body className="max-h-[calc(100vh-180px)] overflow-auto">
                {children}
            </Modal.Body>
        </Modal>
    )
};